var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropdownDarkmode = function SvgDropdownDarkmode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.201 1.672c-6.849.633-10.08 9.371-5.161 14.29 4.918 4.918 13.656 1.687 14.29-5.162a.833.833 0 0 0-1.326-.747c-1.979 1.463-4.826 1.25-6.566-.49-1.74-1.74-1.953-4.587-.49-6.566A.833.833 0 0 0 9.2 1.672M7.703 3.707l-.03.083c-.811 2.373-.251 5.115 1.586 6.952l.165.159c1.833 1.71 4.484 2.214 6.787 1.427l.082-.03-.005.016c-1.61 4.27-7.58 5.959-11.07 2.469-3.437-3.437-1.851-9.279 2.276-10.994z"
  })));
};
export default SvgDropdownDarkmode;